import React from 'react';
import styled, { css } from 'styled-components';
import Content from 'gatsby-theme-core/src/components/content';

const Message = ({ className, content }) => (
  <div className={className}>
    <Content $content={content} />
  </div>
);

export default styled(Message)`
  margin-bottom: 2rem;
  ${({ horizontal }) => horizontal && css`
    margin-bottom: 0;
  `}
`;
